// eslint-disable-next-line import/prefer-default-export
export enum GlobalType {
  CLEAR_LOADED_DATA = 'globalActionType/CLEAR_LOADED_DATA',
  SHOW_LOADING_GLOBAL_COMPONENT = 'globalActionType/SHOW_LOADING_GLOBAL_COMPONENT',
  HIDE_LOADING_GLOBAL_COMPONENT = 'globalActionType/HIDE_LOADING_GLOBAL_COMPONENT'
}
